'use client';

import Markdoc from '@markdoc/markdoc';
import React from 'react';

export default function MarkdocContent({ markdown }: { markdown: string }) {
  const ast = Markdoc.parse(markdown);
  const content = Markdoc.transform(ast, {
    nodes: {
      document: {
        render: 'div'
      }
    }
  });

  return <>{Markdoc.renderers.react(content, React)}</>;
}
